export const mockProvisionalTransaction = {
    type: 'payment-auth',
    message: 'Your transaction is being processed and will be completed shortly.',
    status: 'provisional'
};
